import approvalStatuses from "astrid-firestore/src/api/approval/constants/approvalStatuses";

export default function useApprovedQuery(ref) {
	return ref.where("approval.status", "==", approvalStatuses.APPROVED);
}
